var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessage = function SvgMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.4 10.2h7.2m-7.2 3.6H12m9-1.8a9 9 0 0 1-9 9c-1.025 0-1.905-.146-2.721-.438-.772-.276-1.158-.414-1.306-.449-1.366-.321-1.933.615-3.11.811a.9.9 0 0 1-1.045-.961c.042-.511.395-.994.536-1.485.293-1.02-.105-1.793-.525-2.7A9 9 0 1 1 21 12"
  })));
};
export default SvgMessage;